import { GridSortModel } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../redux/store";
import { selectSortPreferences, setSortPreferences } from "../redux/userSlice";

export default function useDatagridSorting(dataGridName: string) {
	const dispatch = useDispatch();
	const sortPreferences = useSelector((state: RootState) => selectSortPreferences(state));
	const [sortModel, setSortModel] = useState<GridSortModel>([]);

	const handleSortModelChange = (newSortModel: GridSortModel) => {
		const column = newSortModel[0]?.field || "";
		const lastSortedAs = newSortModel[0]?.sort || "";
		const tempSortPreferences = {
			...sortPreferences,
			[dataGridName]: {
				column: column,
				lastSortedAs: lastSortedAs as string
			}
		};
		dispatch(setSortPreferences(tempSortPreferences));
		setSortModel(newSortModel);
	};

	const handleInitializeSortModel = () => {
		const pref = sortPreferences[dataGridName as keyof typeof sortPreferences];
		if (pref?.column) {
			setSortModel([{ field: pref.column, sort: pref.lastSortedAs as GridSortModel[0]["sort"] }]);
		}
	};

	return { sortModel, handleInitializeSortModel, handleSortModelChange };
}
